module.exports = __webpack_public_path__ + "static/media/The Lord of the Rings  1000*1500.d3f0b926.jpg";